export default __webpack_public_path__ + "static/media/flac.8422b566.svg";